import { Button, Col, Form, Input, Modal, Popconfirm, Row, Select, Space, Tooltip, } from 'antd';
import HTTPService from '../../../utils/makerequest';
import { IPageData } from '../../../interfaces/page-data';
import { useEffect, useRef, useState } from 'react';
import { StateLoader } from '../../../redux/StateLoader';
import { IAuthentication, UserRole } from '../../../interfaces/authentication';
import { Toast } from 'primereact/toast';
import '../PrinterManagement/Device.css';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import moment from 'moment';
import MUIDatagrid, { IMUIDataGridColumns } from '../../../AltisComponent/MUIDataGrid';
import { BarcodeOutlined, DeleteOutlined, EditOutlined, ExportOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { ILocationData } from '../../../interfaces/ILocationData';
import { ICampusData } from '../../../interfaces/ICampusData';

const detailColumns: IMUIDataGridColumns[] = [
    {
        title: 'inventoryName',
        key: 'inventoryName',
        placeHolder: 'inventoryName',
        headerAlign: 'left',
        align: 'left',
        render: (value) => {
            return <div style={{ textAlign: 'left' }}>{value}</div>;
        }
    },
    {
        title: 'barcode',
        key: 'barcode',
        placeHolder: 'barcode',
        headerAlign: 'left',
        align: 'left',
        render: (value) => {
            return <div style={{ textAlign: 'left' }}>{value}</div>;
        }
    }
];

const TransferManagement: React.FunctionComponent<any> = (props) => {
    const { onSetPage } = props;
    const { t } = useTranslation();
    const loader = new StateLoader();
    const userInfo: IAuthentication = loader.loadAuthState();
    const [transferData, setTransferData] = useState({ data: [], count: 0 });
    const [isModalDetail, setIsModalDetail] = useState(false);
    const dataGridRef = useRef<any>(null);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [selectedmaintenanceId, setSelectedmaintenanceId] = useState(null);
    const [newIsCompleted, setNewIsCompleted] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [detailData, setDetailData] = useState(null);
    const [selectedInventoryIds, setSelectedInventoryIds] = useState<number[]>([]);
    const [currentTransferId, setCurrentTransferId] = useState<number | null>(null);
    const [locationData, setLocationData] = useState<ILocationData[]>([]);
    const toast = useRef<Toast>(null);
    const [form] = Form.useForm();
    const [showLocationForm, setShowLocationForm] = useState(false);
    const [selectedItemsForTransfer, setSelectedItemsForTransfer] = useState<any[]>([]);
    const [detailSelectedItems, setDetailSelectedItems] = useState<number[]>([]);
    const [campusData, setCampusData] = useState<ICampusData[]>([]);
    const [filteredLocationData, setFilteredLocationData] = useState<ILocationData[]>([]);
    const [columns2, setColumns2] = useState<IMUIDataGridColumns[]>(detailColumns);

    const [transferId, setTransferId] = useState<number>();
    const pageData: IPageData = {
        title: t('transfer'),
        loaded: true,
    };

    useEffect(() => {
        onSetPage(pageData);
        dataGridRef.current.GetAllData()
        fetchAllLocationNameByCompany(userInfo?.companyId);
        fetchCampusesByCompany(userInfo?.companyId);
    }, [i18n.language]);


    const fetchCampusesByCompany = async (companyId: number) => {
        try {
            const result = await HTTPService.GETCampusByCompany(companyId);
            setCampusData(result);
        } catch (error) {
            console.error("Kampüs verilerini alırken bir hata oluştu:", error);
            setCampusData([]);
        }
    };


    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const showModal = (id, currentStatus) => {
        setSelectedmaintenanceId(id);
        setNewIsCompleted(!currentStatus);
        setIsModalVisible(true);
    };

    const handleOk = () => {
        handleCheckboxChange(selectedmaintenanceId, newIsCompleted);
        setIsModalVisible(false);
    };


    const handleCheckboxChange = async (id: number, isCompleted: boolean) => {
        try {
            const response = await HTTPService.PUT(`/Maintenance/isCompleted?maintenanceId=${id}`, {});
            if (response.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: t('success'),
                    detail: t('update_success'),
                    life: 3000
                });
                dataGridRef.current.GetAllData();
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('update_failed'),
                    life: 3000
                });
            }
        } catch (error) {
            console.error('errors:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };


    const handleRowSelection = (newSelection: any) => {
        setSelectedRows(newSelection);
    };

    const DeleteTransfer = (transferId) => {
        HTTPService.DELETE(`/InventoryTransfer/deletetransfer?transferId=${transferId}`).then(
            (response) => {
                if (response.status === 200) {
                    toast.current?.show({
                        severity: 'success',
                        summary: t('success'),
                        detail: t(response.data),
                        life: 3000
                    });
                    dataGridRef.current.GetAllData();
                } else if (response.status === 450) {
                    toast.current?.show({
                        severity: 'warn',
                        summary: t('Warning'),
                        detail: t(response.data),
                        life: 3000
                    });
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t(response.data),
                        life: 3000
                    });
                }
            }
        );
    };

    const handleCancelDetail = () => {
        setIsModalDetail(false);
        setDetailData(null);
        setSelectedInventoryIds([]);
        setDetailSelectedItems([]);
        setShowLocationForm(false);
        form.resetFields();
    }

    const DetailTransfer = async (e, transferId) => {
        try {
            const actualTransferId = typeof transferId === 'object' ? currentTransferId : transferId;

            if (!actualTransferId) return;

            getTransferById(actualTransferId);
            setDetailData(null);
            setSelectedInventoryIds([]);
            form.resetFields();
            setCurrentTransferId(actualTransferId);

            const filters = e?.filters;
            const body = {
                sortColumn: e?.sortField,
                sortOrder: e?.sortOrder || 'asc',
                pageSize: e?.pageSize || 10,
                page: e?.page || 1,
                inventoryName: filters?.inventoryName,
                barcode: filters?.barcode
            };

            const response = await HTTPService.POST(`/InventoryTransfer/transferDetails?transferId=${actualTransferId}`, body);

            if (response.status === 200 && response.data) {
                const formattedData = {
                    data: response.data.data.map(item => ({
                        id: item.inventoryId,
                        inventoryId: item.inventoryId,
                        inventoryName: item.inventoryName,
                        barcode: item.barcode,
                        locationId: item.locationId,
                        locationName: item.locationName || '-',
                        isSelected: false
                    })),
                    count: response.data.count
                };

                setDetailData(formattedData);
                setIsModalDetail(true);
            }
        } catch (error) {
            console.error('DetailTransfer error:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('errorFetchingData'),
                life: 3000
            });
        }
    };

    const getTransferById = async (id: number) => {
        try {
            const response = await HTTPService.GET(`/InventoryTransfer/ById?transferId=${id}`);
            if (response.status === 200 && response.data && response.data.length > 0) {
                const transferData = response.data[0].transferTBL;

                form.setFieldsValue({
                    description: transferData.transferReceivedDescription
                });
            }
        } catch (error) {
            console.error('Error fetching transfer:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_fetching_transfer'),
                life: 3000
            });
        }
    };

    const completeTransfer = async (inventoryIds: number[], transferId: number) => {
        try {
            const locationId = form.getFieldValue('locationId');
            const campusId = form.getFieldValue('campusId');
            const description = form?.getFieldValue('description');

            if (!campusId) {
                toast.current?.show({
                    severity: 'warn',
                    summary: t('Warning'),
                    detail: t('select_campus'),
                    life: 3000
                });
                return;
            }

            if (!locationId) {
                toast.current?.show({
                    severity: 'warn',
                    summary: t('Warning'),
                    detail: t('please_select_location'),
                    life: 3000
                });
                return;
            }

            if (!inventoryIds || inventoryIds.length === 0) {
                toast.current?.show({
                    severity: 'warn',
                    summary: t('Warning'),
                    detail: t('please_select_items'),
                    life: 3000
                });
                return;
            }

            const requestBody = {
                completeTransfer: inventoryIds.map(inventoryId => ({
                    inventoryId: inventoryId,
                    transferId: transferId
                })),
                locationId: locationId,
                description: description,
                companyId: userInfo?.companyId
            };


            const response = await HTTPService.POST('/InventoryTransfer/completeTransfer', requestBody);

            if (response.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: t('success'),
                    detail: t('transfer_completed_successfully'),
                    life: 3000
                });
                handleCancelDetail();
                dataGridRef.current.GetAllData();
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: t('error'),
                    detail: t('transfer_completion_failed'),
                    life: 3000
                });
            }
        } catch (error) {
            console.error('Complete transfer error:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const TransferFilter = (e?) => {
        const filters = e?.filters;

        if (filters?.transferStartDate && Array.isArray(filters.transferStartDate)) {
            const [startDate, endDate] = filters.transferStartDate;
            filters.transferStartDate = startDate;
            filters.transferFinishDate = endDate;
            // delete filters.transferStartDate;
        }

        const body = {
            sortColumn: e?.sortField,
            sortOrder: e?.sortOrder || 'asc',
            pageSize: e?.pageSize,
            page: e?.page,
            companyId: userInfo?.companyId,
            ...filters,
        };

        HTTPService.POST(`/InventoryTransfer/filters`, body).then((response) => {
            if (!response.data) return;
            if (response.status === 200) {
                const mappedData = response.data.data.map(item => {
                    const locationName = item.locationNames.find(
                        loc => item.locationIds.includes(loc.locationId)
                    )?.locationName || '-';

                    return {
                        ...item,
                        prevLocation: locationName
                    };
                });

                setTransferData({
                    data: mappedData,
                    count: response.data.count
                });

            } else if (response.status === 450) {
                toast.current?.show({
                    severity: 'error',
                    summary: t('mistake'),
                    detail: t(response.data),
                    life: 3000
                });
            }
        });
    };

    const fetchAllLocationNameByCompany = async (companyId: number) => {
        try {
            const result = await HTTPService.GETAllLocationNames(userInfo?.companyId);
            setLocationData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('error'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const handleCampusChange = async (selectedCampusId: number) => {
        try {
            // Lokasyon alanını sıfırla
            form.setFieldValue('locationId', undefined);

            // Seçilen kampüse ait lokasyonları filtrele
            const response = await HTTPService.GET(`/Location/allLocationNameByCampus?campusId=${selectedCampusId}`);
            if (response.status === 200) {
                setFilteredLocationData(response.data || []);
                // Form field'ını explicity reset et
                form.setFields([
                    {
                        name: 'locationId',
                        errors: []
                    }
                ]);
            }
        } catch (error) {
            console.error('Lokasyon verilerini alırken hata:', error);
            setFilteredLocationData([]);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_fetching_locations'),
                life: 3000
            });
        }
    };

    const columns: IMUIDataGridColumns[] = [
        ...(userInfo.role == UserRole.AltisAdmin ? [{
            title: t('Company Name'),
            key: 'companyName',
            isSorting: true,
            placeHolder: t('Company Name'),
        }] : []),
        {
            title: t('transferinventoryName'),
            key: 'inventoryName',
            placeHolder: t('transferinventoryName'),
            isSorting: true,
            render: (value) => {
                if (Array.isArray(value)) {
                    const displayItems = value.slice(0, 3);
                    const remainingCount = value.length - 3;
                    const displayText = displayItems.join(', ') + (remainingCount > 0 ? ` ...` : '');

                    return (
                        <div style={{
                            textAlign: 'left',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>
                            {displayText}
                        </div>
                    );
                }
                return <div style={{ textAlign: 'left' }}>{value}</div>;
            }
        },
        {
            title: t('destination'),
            key: 'destination',
            placeHolder: t('destination'),
            isSorting: true,
            headerAlign: 'left',
            align: 'left',
        },
        {
            title: t('transferManager'),
            key: 'transferManager',
            placeHolder: t('transferManager'),
            align: 'left',
        },
        {
            title: t('transferDescription'),
            key: 'transferDescription',
            placeHolder: t('transferDescription'),
            render: (value) => {
                return <div style={{ textAlign: 'left' }}>{t(value)}</div>;
            }
        },
        {
            title: t('transferStartDate'),
            key: 'transferStartDate',
            placeHolder: t('transferStartDate'),
            dataType: 'date',
            render: (text) => {
                return moment(text).format('DD-MM-YYYY HH:mm')
            }
        },
        {
            title: t('operations'),
            key: 'operations',
            placeHolder: t('Operations'),
            isSorting: false,
            hideColumnMenu: true,
            render: (order, record) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                        <Space size={4}>
                            {/* <Popconfirm
                                title={<div>{t('are_you_sure_licence')} <br /></div>}
                                onConfirm={() => DeleteTransfer(record.transferId)}
                                okText={t('yes')}
                                cancelText={t('no')}
                            >
                                <Tooltip title={t('delete')} placement="top">
                                    <Button
                                        size='small'
                                        icon={<DeleteOutlined />}
                                        style={{
                                            display: userInfo.role === UserRole.Personel ? 'none' : 'inline-block',
                                            width: '60px',
                                            borderRadius: '70px'
                                        }}
                                        disabled={record.isCompleted}
                                    />
                                </Tooltip>
                            </Popconfirm> */}

                            <Tooltip title={t('details')} placement="top">
                                <Button
                                    size='small'
                                    icon={<UnorderedListOutlined />}
                                    style={{ width: '60px', borderRadius: '70px' }}
                                    onClick={() => {
                                        setTransferId(record.transferId);
                                        DetailTransfer(record, record.transferId);
                                    }}
                                />
                            </Tooltip>

                            <Tooltip title={t('update')} placement="top">
                                <Button
                                    size='small'
                                    icon={<EditOutlined />}
                                    style={{
                                        display: userInfo.role === UserRole.Personel ? 'none' : 'inline-block',
                                        width: '60px',
                                        borderRadius: '70px'
                                    }}
                                    onClick={() => {
                                        window.location.replace(`/admin/add-edit-transfer/${record.transferId}`);
                                    }}
                                    disabled={record.isCompleted}
                                />
                            </Tooltip>
                        </Space>
                    </div>
                );
            },
        },
    ];

    const handleDetailSelectionChange = (newSelection: any[]) => {

        // newSelection MUIDatagrid'den gelen tam obje array'idir
        // inventory ID'lerini çıkar
        const selectedInventoryIds = newSelection.map(item => item.inventoryId);

        setDetailSelectedItems(selectedInventoryIds);

        setDetailData(prevData => ({
            ...prevData,
            data: prevData.data.map(item => ({
                ...item,
                isSelected: selectedInventoryIds.includes(item.inventoryId)
            }))
        }));
    };


    const handleTransferClick = () => {

        if (!detailSelectedItems || detailSelectedItems.length === 0) {
            toast.current?.show({
                severity: 'warn',
                summary: t('Warning'),
                detail: t('please_select_items'),
                life: 3000
            });
            return;
        }

        // detailSelectedItems artık inventory ID array'i
        const selectedItems = detailData?.data?.filter(item =>
            detailSelectedItems.includes(item.inventoryId)
        );

        if (!selectedItems || selectedItems.length === 0) {
            toast.current?.show({
                severity: 'warn',
                summary: t('Warning'),
                detail: t('please_select_items'),
                life: 3000
            });
            return;
        }

        setSelectedItemsForTransfer(selectedItems);
        setShowLocationForm(true);
    };


    const handleFinalSubmit = async () => {
        // Form validation için etkinleştirilmiş öğeleri kontrol et
        const campusId = form.getFieldValue('campusId');
        const locationId = form.getFieldValue('locationId');
        const description = form.getFieldValue('description');

        if (!campusId) {
            toast.current?.show({
                severity: 'warn',
                summary: t('Warning'),
                detail: t('select_campus'),
                life: 3000
            });
            return;
        }

        if (!locationId) {
            toast.current?.show({
                severity: 'warn',
                summary: t('Warning'),
                detail: t('please_select_location'),
                life: 3000
            });
            return;
        }

        const inventoryIds = selectedItemsForTransfer.map(item => item.inventoryId);

        if (inventoryIds.length === 0) {
            toast.current?.show({
                severity: 'warn',
                summary: t('Warning'),
                detail: t('please_select_items'),
                life: 3000
            });
            return;
        }

        completeTransfer(inventoryIds, currentTransferId);
    };

    return (
        <>
            <Toast ref={toast} />
            <Row gutter={16} style={{ marginTop: '20px' }}>
                <Col xs={24} sm={8} md={6} lg={4} xl={4} style={{ paddingLeft: '8px' }}>
                    <Button
                        type="primary"
                        shape="round"
                        style={{
                            height: 64,
                            width: 'auto',
                            backgroundColor: 'transparent',
                            color: '#1890ff',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '5px',
                            padding: 0,
                            border: 'none',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                            e.currentTarget.style.color = '#40a9ff';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                            e.currentTarget.style.color = '#1890ff';
                        }}
                        size="middle"
                        hidden={userInfo.role === UserRole.Personel}
                        icon={<ExportOutlined style={{ fontSize: 24 }} />}
                        onClick={() => window.location.replace('/admin/add-edit-transfer')}
                    >
                        <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                            {t('addTransfer')}
                        </span>
                    </Button>
                </Col>

                <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ marginTop: '10px', paddingLeft: '8px' }}>
                    <MUIDatagrid
                        ref={dataGridRef}
                        data={transferData.data}
                        total={transferData.count}
                        columns={columns}
                        onSelectionChange={handleRowSelection}
                        enableSelection={false}
                        onChange={TransferFilter}
                        filterMode='server'
                    />
                </Col>

                <Modal
                    title={<span style={{ fontWeight: 'bold' }}>{t('completedStatus')}</span>}
                    visible={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                >
                    <p>{t('isCompletedModalMessage')}</p>
                </Modal>

                <Modal
                    title={<span style={{ fontWeight: 'bold' }}>{t('details')}</span>}
                    visible={isModalDetail}
                    onCancel={handleCancelDetail}
                    footer={null}
                    width={800}
                    destroyOnClose={true}
                >
                    <Form form={form}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0 0 16px 0',
                                borderBottom: '1px solid #f0f0f0'
                            }}>
                                {!showLocationForm ? (
                                    <Button
                                        type="primary"
                                        shape="round"
                                        style={{
                                            minWidth: '150px',
                                            height: '40px',
                                            borderRadius: '5px',
                                        }}
                                        onClick={handleTransferClick}
                                    >
                                        {t('isTransferCompleted')}
                                    </Button>
                                ) : (
                                    <Button
                                        type="primary"
                                        shape="round"
                                        style={{
                                            minWidth: '150px',
                                            height: '40px',
                                            borderRadius: '5px',
                                        }}
                                        onClick={handleFinalSubmit}
                                    >
                                        {t('complete_transfer')}
                                    </Button>
                                )}
                            </div>

                            {showLocationForm && (
                                <div style={{
                                    padding: '16px',
                                    background: '#fafafa',
                                    borderRadius: '8px',
                                    marginBottom: '16px'
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '16px',
                                        width: '100%'
                                    }}>
                                        <Form.Item
                                            name='campusId'
                                            label={<span style={{ display: 'inline-block', width: '100px' }}>{t('campus')}</span>}
                                            rules={[{ required: true, message: t('select_campus') }]}
                                            style={{
                                                width: '100%',
                                                marginBottom: '16px'
                                            }}
                                            labelCol={{ flex: '100px' }}
                                            wrapperCol={{ flex: 'auto' }}
                                        >
                                            <Select
                                                placeholder={t('campus')}
                                                style={{ width: '100%' }}
                                                onChange={handleCampusChange}
                                            >
                                                {campusData.map(row => (
                                                    <Select.Option key={row.campusId} value={row.campusId}>
                                                        {row.campusName}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>

                                        <Form.Item
                                            name="locationId"
                                            label={<span style={{ display: 'inline-block', width: '100px' }}>{t('location')}</span>}
                                            rules={[{ required: true, message: t('please_select_location') }]}
                                            style={{
                                                width: '100%',
                                                marginBottom: '16px'
                                            }}
                                            labelCol={{ flex: '100px' }}
                                            wrapperCol={{ flex: 'auto' }}
                                        >
                                            <Select
                                                placeholder={t('location')}
                                                style={{ width: '100%' }}
                                                dropdownStyle={{ minWidth: 300 }}
                                                showSearch
                                                optionFilterProp="children"
                                                disabled={!form.getFieldValue('campusId')}
                                                allowClear
                                            >
                                                {filteredLocationData && filteredLocationData.length > 0 ? (
                                                    filteredLocationData.map(row => (
                                                        <Select.Option key={row.locationId} value={row.locationId}>
                                                            {row.locationName}
                                                        </Select.Option>
                                                    ))
                                                ) : (
                                                    <Select.Option value="" disabled>
                                                        {t('no_location_available')}
                                                    </Select.Option>
                                                )}
                                            </Select>
                                        </Form.Item>

                                        <Form.Item
                                            name='description'
                                            label={<span style={{ display: 'inline-block', width: '100px' }}>{t('description')}</span>}
                                            rules={[{ required: false }]}
                                            style={{
                                                width: '100%',
                                                marginBottom: '0'
                                            }}
                                            labelCol={{ flex: '100px' }}
                                            wrapperCol={{ flex: 'auto' }}
                                        >
                                            <Input
                                                placeholder={t('enter_description')}
                                                style={{
                                                    width: '100%',
                                                    borderRadius: '4px'
                                                }}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            )}

                            <div style={{
                                flex: 1,
                                background: '#fff',
                                borderRadius: '8px',
                                boxShadow: '0 1px 2px rgba(0,0,0,0.03)'
                            }}>
                                <MUIDatagrid
                                    data={detailData?.data}
                                    total={detailData?.count}
                                    columns={columns2}
                                    enableSelection={true}
                                    onSelectionChange={handleDetailSelectionChange}
                                    onChange={(e) => DetailTransfer(e, transferId)}
                                    filterMode='server'
                                />
                            </div>
                        </div>
                    </Form>
                </Modal>


            </Row>
        </>
    );
};


export default TransferManagement;
